// Import model
import { DataviewWoodCatalogItemResponse } from '../models/DataviewWoodCatalogItemResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterWoodCatalogItemRequest } from '../models/FilterWoodCatalogItemRequest';
import { WoodCatalogItem } from '../models/WoodCatalogItem';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterWoodCatalogItemRequestSerializer } from './FilterWoodCatalogItemRequestSerializer';
import { WoodCatalogItemSerializer } from './WoodCatalogItemSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewWoodCatalogItemResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewWoodCatalogItemResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewWoodCatalogItemResponse instance
   */
  static deserialize(json: string): DataviewWoodCatalogItemResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewWoodCatalogItemResponse instance
   */
  static fromObject(obj: any): DataviewWoodCatalogItemResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewWoodCatalogItemResponse');
    }


    const instance: DataviewWoodCatalogItemResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        WoodCatalogItemSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterWoodCatalogItemRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewWoodCatalogItemResponse instances
   */
  static deserializeArray(json: string): DataviewWoodCatalogItemResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewWoodCatalogItemResponse instance to a JSON string
   */
  static serialize(instance: DataviewWoodCatalogItemResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewWoodCatalogItemResponse instance to a plain object
   */
  static toObject(instance: DataviewWoodCatalogItemResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        WoodCatalogItemSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterWoodCatalogItemRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewWoodCatalogItemResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewWoodCatalogItemResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
